 /*=========================================================================================
  File Name: mutations.js
  Description: Opening Hours Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Opening Hours  State Module
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'

export default {

    SET_OPENINGTIMESTABLE_STATE ( state, payload ) {
        
        //
        //transform time object to moment objet
        //

        payload.forEach(o => {
            o.fromTime = moment(o.fromTime, 'HH:mm'); 
            o.toTime = moment(o.toTime, 'HH:mm');
            o.canOrderFrom = moment(o.canOrderFrom, 'HH:mm');
            o.cannotOrderFrom = moment(o.cannotOrderFrom, 'HH:mm');
            o.offTime = moment(o.offTime, 'HH:mm');
        });

        state.openingHours = payload;

    },

    UPDATE_OPENINGTIME_STATE ( state, payload ) {
        
        let index = state.openingHours.findIndex( o => o.label == payload.label );

        if (index > -1) {
            state.openingHours[index] = payload;
        }
    },

    SET_CURRENT_LOCAL_TIME_STATE (state, payload) {
        state.currentLocalTime = payload;
    },

    SET_CURRENT_OPENING_HOURS_STATE(state, payload) {

        if (state.currentLocalTime == null) {
            state.currentLocalTime = moment();
        }

        state.fromTime = moment(payload.fromTime, 'HH:mm:ss');
        state.toTime = moment(payload.toTime,'HH:mm:ss');

        let fromTime = moment(state.fromTime, 'HH:mm:ss').hours();
        let toTime = moment(state.toTime, 'HH:mm:ss').hours();
        let currentTime = moment(state.currentLocalTime, 'HH:mm:ss').hours();

        if(fromTime < currentTime) {
            fromTime = currentTime
        }

        for (var i = 0; i < fromTime; i++) {
            state.disabledHours.push(i);
        }

        for (var j = toTime; j < 24; j++) {
            state.disabledHours.push(j);
        }
    }
}